module.exports = __webpack_public_path__ + "img/en.87c6363.png";